import { defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import {
  regex,
  required,
  email,
  alpha_dash,
  alpha_num,
  numeric,
  between,
} from "@vee-validate/rules";
import en from "@vee-validate/i18n/dist/locale/en.json";
import ru from "./locales/ru.js";

/* Чёрный список */
const blackList = ["Passw0rd", "Password123"];

defineRule("required", required);
defineRule("regex", regex);
defineRule("email", email);
defineRule("alpha_dash", alpha_dash);
defineRule("alpha_num", alpha_num);
defineRule("numeric", numeric);
defineRule("between", between);

defineRule("decimal", (value, [decimals = "*", separator = "."]) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }
  const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
  const regex = new RegExp(
    `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`,
  );

  return regex.test(value);
});

defineRule("min", (value, [length]) => {
  return value.length >= length;
});

defineRule("max", (value, [length]) => {
  return value.length <= length;
});

defineRule("gt", (value, [input]) => {
  return +value > +input;
});

defineRule("gte", (value, [input]) => {
  return +value >= +input;
});

defineRule("gte_with_coin", (value, [input]) => {
  return +value >= +input;
});

defineRule("lt", (value, [input]) => {
  return +value < +input;
});

defineRule("lte", (value, [input]) => {
  return +value <= +input;
});

defineRule("lte_with_coin", (value, [input]) => {
  return +value <= +input;
});

// Check that balance is greater than min limit for the operation
defineRule("balance_limit", (value, [min, balance]) => {
  return parseFloat(balance) >= parseFloat(min);
});

defineRule("min_limit", (value, { minLimit, balance }) => {
  return parseFloat(minLimit) < parseFloat(balance);
});

// Check that daily left limit is greater than min limit for the operation
defineRule("daily_left_limit", (value, [minLimit, dailyLeft]) => {
  return parseFloat(dailyLeft) >= parseFloat(minLimit);
});

defineRule("no_spaces", (value) => {
  return value.indexOf(" ") !== 0;
});

defineRule("blacklist", (value) => !blackList.includes(value));

defineRule("password", (value, [password]) => value === password);

const dictionary = {
  ru: {
    fields: {},
    messages: {
      ...ru.messages,
      lte: "Поле {field} должно быть меньше либо равно 0:{input}",
      lte_with_coin:
        "Максимально <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      lt: "Поле {field} должно быть меньше чем 0:{input}",
      gte: "Поле {field} должно быть больше либо равно 0:{input}",
      gte_with_coin:
        "Минимально <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      gt: "Поле {field} должно быть больше чем 0:{input}",
      min: "Поле {field} должно быть не менее 0:{length} символов.",
      balance_limit: "Недостаточно средств",
      daily_left_limit: "Превышен дневной лимит",
      min_limit:
        "Минимально <span class='error-message-sum'>{minLimit} {coin}</span>",
    },
    names: {
      Amount: "сумма",
      Percentage: "процент",
      "Card number": "Номер карты",
    },
  },
  en: {
    messages: {
      ...en.messages,
      lte: "{field} field needs to be less than or equal to 0:{input}",
      lte_with_coin:
        "Maximum <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      lt: "{field} field needs to be less than 0:{input}",
      gte: "{field} field needs to be greater than or equal to 0:{input}",
      gte_with_coin:
        "Minimum <span class='error-message-sum'>0:{input} 1:{coin}</span>",
      gt: "{field} field needs to be greater than 0:{input}",
      balance_limit: "Insufficient balance",
      daily_left_limit: "Daily limit exceeded",
      min_limit:
        "Minimum <span class='error-message-sum'>{minLimit} {coin}</span>",
    },
    names: {},
  },
};

configure({
  generateMessage: localize(dictionary),
  classes: {
    valid: "is-valid",
    invalid: ["is-invalid", "error"],
  },
});
